import { type ReactNode } from 'react'
import { Outlet, ScrollRestoration } from 'react-router-dom'
import css from './AuthLayout.module.css'

export function AuthLayout() {
  return (
    <div className={css.rootAuth}>
      <div className={css.container}>
        <div className={css.content}>
          <Outlet />
        </div>
      </div>
      <ScrollRestoration />
    </div>
  )
}
